// extracted by mini-css-extract-plugin
export default {"actions":"_34XzY","star":"_27LUc","starFilled":"_1nPFn","insideModal":"_2K6C3","wired":"LhC2f"};